export default {
  generic: {
    title: "An error occurred",
    message: "An unexpected error occurred. Please try again.",
    retry: "Retry",
    contact: "If the problem persists, contact support."
  },
  network: {
    title: "Network error",
    offline: "You are offline. Check your internet connection.",
    timeout: "Request timed out. Please try again.",
    serverError: "Server error. Please try again later."
  },
  authentication: {
    title: "Authentication error",
    unauthorized: "You are not authorized to access this resource.",
    sessionExpired: "Your session has expired. Please log in again.",
    invalidCredentials: "Invalid credentials.",
    forbidden: "Access forbidden."
  },
  validation: {
    required: "This field is required",
    invalidEmail: "Invalid email address",
    invalidFormat: "Invalid format",
    minLength: "Minimum length: {{min}} characters",
    maxLength: "Maximum length: {{max}} characters",
    minValue: "Minimum value: {{min}}",
    maxValue: "Maximum value: {{max}}"
  },
  notFound: {
    title: "Page not found",
    message: "The page you are looking for does not exist.",
    goHome: "Go to home"
  },
  api: {
    "400": "Bad request",
    "401": "Unauthorized",
    "403": "Forbidden",
    "404": "Resource not found",
    "500": "Internal server error",
    "503": "Service temporarily unavailable"
  }
};
